// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","252":"b19777dc","455":"754e5c46","977":"f49d09dd"}[chunkId] + ".chunk.js";
};